import { FC } from 'react';
import Cookies from 'js-cookie';
import { getAuthCookiesName } from '@shared/helpers/getAuthCookiesName.helper';
import { ButtonMenuContainer, Custom, HeaderLayoutContainer, LeftSide, MiddleSide, RightSide } from './HeaderLayout.style';
import MainMenuLogoLogic from './logo/MenuLogo.logic';
import MainMenuLogic from './mainMenu/MainMenu.logic';
import HamburgerMenuLogic from './option/hamburger/Hamburger.logic';
import LoginButtonLogic from './option/loginButton/LoginButton.logic';
import ProfileButtonLogic from './option/profileButton/ProfileButton.logic';
interface Props {
  onOpenSearchModal: () => void;
}
const HeaderLayout: FC<Props> = ({
  onOpenSearchModal
}: Props) => {
  return <HeaderLayoutContainer>
            <LeftSide>
                <MainMenuLogoLogic />
            </LeftSide>
            <MiddleSide>
                <MainMenuLogic />
            </MiddleSide>
            <RightSide>
                <ButtonMenuContainer>
                    {Cookies.get(getAuthCookiesName()) ? <ProfileButtonLogic /> : <LoginButtonLogic />}

                    <HamburgerMenuLogic />
                    <Custom.Button onClick={onOpenSearchModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M11.5837 20.1248C6.87533 20.1248 3.04199 16.2915 3.04199 11.5832C3.04199 6.87484 6.87533 3.0415 11.5837 3.0415C16.292 3.0415 20.1253 6.87484 20.1253 11.5832C20.1253 16.2915 16.292 20.1248 11.5837 20.1248ZM11.5837 4.2915C7.55866 4.2915 4.29199 7.5665 4.29199 11.5832C4.29199 15.5998 7.55866 18.8748 11.5837 18.8748C15.6087 18.8748 18.8753 15.5998 18.8753 11.5832C18.8753 7.5665 15.6087 4.2915 11.5837 4.2915Z" fill={"#585858"} />
                            <path d="M20.3339 20.9581C20.1755 20.9581 20.0172 20.8998 19.8922 20.7748L18.2255 19.1081C17.9839 18.8665 17.9839 18.4665 18.2255 18.2248C18.4672 17.9831 18.8672 17.9831 19.1089 18.2248L20.7755 19.8915C21.0172 20.1331 21.0172 20.5331 20.7755 20.7748C20.6505 20.8998 20.4922 20.9581 20.3339 20.9581Z" fill={"#585858"} />
                        </svg>
                    </Custom.Button>
                </ButtonMenuContainer>
            </RightSide>
        </HeaderLayoutContainer>;
};
export default HeaderLayout;